import { withStyles } from '@material-ui/core/styles';
import Tree from './Tree';
import styles from './Tree.styles';

export default withStyles(styles)(Tree);
